/**
 * Only an explicit `false` counts. The spec defines it as "will not contact the network, or knows the
 * attempt would fail", so it can be trusted; `true` only means a network interface exists and proves nothing.
 */
export const isOffline = (): boolean => typeof navigator !== 'undefined' && navigator.onLine === false;

/** ±30% spread for fleet-wide retry timers, so thousands of pages do not retry in the same second. */
export const jitter = (ms: number): number => Math.round(ms * (0.7 + Math.random() * 0.6));
